import {
  makeShippingAddressDetails,
  makeShippingAndBillingContactParameters,
  makePaymentTokenParameters,
  syncAjaxGET,
  syncAjaxPOST,
} from '../../libs/apple-pay-helpers'
import { APPLE_PAY_CONSTRUCT_PAYMENT_REQUEST, APPLE_PAY_SET_LOADING } from '../mutations/apple-pay'

import { ACTION_TRACK_APPLEPAY_CLICK, ACTION_TRACK_APPLEPAY_ERROR } from './pdp'

export const ACTION_APPLE_PAY_SEND_PAYMENT_TOKEN = 'ACTION_APPLE_PAY_SEND_PAYMENT_TOKEN'
export const ACTION_APPLE_PAY_SEND_RETURN_PAYMENT_TOKEN =
  'ACTION_APPLE_PAY_SEND_RETURN_PAYMENT_TOKEN'
export const ACTION_APPLE_PAY_RETRIEVE_WC_ORDER_INFORMATION =
  'ACTION_APPLE_PAY_RETRIEVE_WC_ORDER_INFORMATION'
export const ACTION_APPLE_PAY_CANCEL_ORDER = 'ACTION_APPLE_PAY_CANCEL_ORDER'
export const ACTION_APPLE_PAY_RENDER_PAYMENT_SHEET = 'ACTION_APPLE_PAY_RENDER_PAYMENT_SHEET'
export const ACTION_APPLE_PAY_UPDATE_SHIPPING_METHOD = 'ACTION_APPLE_PAY_UPDATE_SHIPPING_METHOD'
export const ACTION_APPLE_PAY_UPDATE_SHIPPING_ADDRESS = 'ACTION_APPLE_PAY_UPDATE_SHIPPING_ADDRESS'
export const ACTION_APPLE_PAY_VALIDATE_MERCHANT = 'ACTION_APPLE_PAY_VALIDATE_MERCHANT'
export const ACTION_APPLE_PAY_UPDATE_ORDER_SUMMARY = 'ACTION_APPLE_PAY_UPDATE_ORDER_SUMMARY'
import { ORDER_OK_VIEW } from '@/scripts/constants/pages'

import { DESKTOP } from '@/scripts/constants/media-query'
import { FROM_PAGE_NAME } from '@/scripts/constants/parameters'
import { SHOP_CART } from '@/scripts/constants/pages'

export const actions = {
  [ACTION_APPLE_PAY_UPDATE_ORDER_SUMMARY]: ({ getters: { commonParameters } }, { city }) => {
    // TODO: Remove global funciton calls and dom manipulations when vue app will have more control on pages
    window.SetCookie('TaxChange', 'yes')
    window.SetCookie('ClearDeliveryFormData', 'yes')

    const request = syncAjaxGET(`CalculateView?${commonParameters}`)

    const orderSummary = document.getElementById('orderSummary')
    if (orderSummary) {
      orderSummary.innerHTML = request.responseText
    }

    const subTotal = document.getElementById('subTotal')
    const subTotalCalc = document.getElementById('subTotalCalc')

    if (subTotal && subTotalCalc) {
      subTotal.innerHTML = subTotalCalc.innerHTML
    }

    window.calculate_tax_fn()
    if (window.checkout_giftcard_validation) {
      window.checkout_giftcard_validation()
    }
    window.giftcard_bindevents_fn()
    window.dropscrollerFn()
    window.select_dropbox_value()
    window.expand_dropbox()
    window.collapse_dropbox()
    window.key_nav_dropdown()
    window.tax_submit_fn()
    window.apply_promo_link_click()
    window.apply_promo_idme_link_click()
    window.idme_links()
    window.promo_textbox_focusBlur()
    window.apply_promotion()
    window.remove_promotion()
    window.dropscroller_hover_fn()

    const countryCodeInput1 = document.getElementById('countryCode')
    const country = document.getElementById('country')

    const countryCode = (countryCodeInput1 && countryCodeInput1.value) || (country && country.value)
    let checkoutNow = document.getElementById('checkoutnow')

    if (countryCode === 'US') {
      const cityQueryParam = `'&city=${city}`
      const initialLink = checkoutNow.getAttribute('href')
      const index = initialLink.search('&city')

      if (index !== -1) {
        const newLink = initialLink.slice(0, index).concat(cityQueryParam)

        checkoutNow.setAttribute('href', newLink)
      } else {
        checkoutNow.setAttribute('href', initialLink + cityQueryParam)
      }
    }
  },
  [ACTION_APPLE_PAY_VALIDATE_MERCHANT]: (
    { state, commit, getters: { commonParameters } },
    validationURL
  ) => {
    try {
      const request = syncAjaxPOST(
        `/webapp/wcs/stores/servlet/AjaxApplePayMerchantValidation?${commonParameters}&applePaySessionURL=${validationURL}`
      )

      const parsedMerchantSession = JSON.parse(request.responseText)

      state.applePaySession.completeMerchantValidation(
        JSON.parse(parsedMerchantSession.merchantSessionObject)
      )
    } catch (e) {
      commit(APPLE_PAY_SET_LOADING, false)
    }
  },
  [ACTION_APPLE_PAY_RENDER_PAYMENT_SHEET]: ({ state, commit, dispatch }, mq) => {
    state.applePaySession = new ApplePaySession(2, state.paymentRequest)

    state.applePaySession.onvalidatemerchant = (e) => {
      dispatch(ACTION_APPLE_PAY_VALIDATE_MERCHANT, e.validationURL)
    }

    state.applePaySession.onshippingcontactselected = (e) => {
      dispatch(ACTION_APPLE_PAY_UPDATE_SHIPPING_ADDRESS, {
        shippingContact: e.shippingContact,
      })
    }

    state.applePaySession.onshippingmethodselected = (e) => {
      dispatch(ACTION_APPLE_PAY_UPDATE_SHIPPING_METHOD, e.shippingMethod)
    }

    state.applePaySession.onpaymentauthorized = (e) => {
      state.strategy.onPaymentAuthorized({ dispatch }, e.payment, mq)
    }

    state.applePaySession.oncancel = () => {
      state.strategy.onCancelApplePay({ dispatch })
    }

    commit(APPLE_PAY_SET_LOADING, true)
    state.applePaySession.begin()
  },
  [ACTION_APPLE_PAY_CANCEL_ORDER]: ({ commit }) => {
    commit(APPLE_PAY_SET_LOADING, false)
  },
  [ACTION_APPLE_PAY_RETRIEVE_WC_ORDER_INFORMATION]: ({ commit, getters: { commonParameters } }) => {
    try {
      const response = syncAjaxGET(`/GetPaymentRequestData?${commonParameters}`)

      const data = JSON.parse(response.responseText)

      for (let i = 0; i < data.shippingMethods.length; i++) {
        if (data.shippingMethods[i].identifier == data.defaultShipModeId) {
          if (i == 0) {
            break
          } else {
            const tmp = data.shippingMethods[0]
            data.shippingMethods[0] = data.shippingMethods[i]
            data.shippingMethods[i] = tmp
          }
        }
      }

      commit(APPLE_PAY_CONSTRUCT_PAYMENT_REQUEST, {
        data,
      })
    } catch (e) {
      commit(APPLE_PAY_SET_LOADING, false)
    }
  },
  [ACTION_APPLE_PAY_UPDATE_SHIPPING_METHOD]: (
    { state, dispatch, getters: { commonParameters } },
    shippingMethod
  ) => {
    try {
      syncAjaxPOST(
        `AjaxShipChargeUpdate?isApplePay=true&${commonParameters}&shipModeId=${shippingMethod.identifier}`
      )

      dispatch(ACTION_APPLE_PAY_RETRIEVE_WC_ORDER_INFORMATION)

      state.applePaySession.completeShippingMethodSelection(
        ApplePaySession.STATUS_SUCCESS,
        state.paymentRequest.total,
        state.paymentRequest.lineItems
      )
    } catch (e) {
      state.applePaySession.completeShippinMethodSelection(ApplePaySession.STATUS_FAILURE)
    }
  },
  [ACTION_APPLE_PAY_UPDATE_SHIPPING_ADDRESS]: (
    {
      state,
      dispatch,
      getters: { isInitialShippingAddressValid, commonParameters, selectedShippingModeIdParameter },
    },
    { shippingContact }
  ) => {
    if (state.addressDebug !== true && !isInitialShippingAddressValid(shippingContact)) {
      state.applePaySession.completeShippingContactSelection(
        ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
        state.paymentRequest.shippingMethods,
        state.paymentRequest.total,
        state.paymentRequest.lineItems
      )
      return
    }

    const caAddress = state.countryCode === 'CA' ? 'true' : 'false'

    try {
      const shippingDetails = makeShippingAddressDetails(shippingContact)

      let request = syncAjaxPOST(
        'AjaxOrderCalculate',
        `isApplePay=true&CAAddress=${caAddress}&${commonParameters}${shippingDetails}` +
          `&${FROM_PAGE_NAME}=DeliveryDetailsView&updatePrices=0&addressFlag=${state.strategy.makeAddressFlag(
            state.countryCode
          )}` +
          `&calculationUsageId=-3&calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-4&shipModeId=${selectedShippingModeIdParameter}`,
        'application/x-www-form-urlencoded'
      )

      let data = request.response

      if (typeof data !== 'object') {
        data = JSON.parse(data)
      }

      if (
        (data.errorCode && data.errorCode !== '') ||
        (data.errorMessageKey && data.errorMessageKey !== '')
      ) {
        state.applePaySession.completeShippingContactSelection(
          ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
          state.paymentRequest.shippingMethods,
          state.paymentRequest.total,
          state.paymentRequest.lineItems
        )
      } else {
        dispatch(ACTION_APPLE_PAY_RETRIEVE_WC_ORDER_INFORMATION)

        state.applePaySession.completeShippingContactSelection(
          ApplePaySession.STATUS_SUCCESS,
          state.paymentRequest.shippingMethods,
          state.paymentRequest.total,
          state.paymentRequest.lineItems
        )
      }

      state.strategy.onUpdateShippingAddressSuccess({ dispatch }, shippingContact)
    } catch (e) {
      state.applePaySession.completeShippingContactSelection(ApplePaySession.STATUS_FAILURE)
    }
  },
  [ACTION_APPLE_PAY_SEND_PAYMENT_TOKEN]: (
    {
      state,
      dispatch,
      getters: {
        commonParameters,
        isShippingContactValid,
        isFinalShippingAddressValid,
        isBillingContactValid,
        selectedShippingModeIdParameter,
      },
    },
    { payment, mq }
  ) => {
    if (state.addressDebug !== true && state.performValidation) {
      if (!isShippingContactValid(payment.shippingContact, state.shippingContactValidationRules)) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT)
        return
      }

      if (
        !isFinalShippingAddressValid(
          payment.shippingContact,
          state.shippingAddressFinalValidationRules,
          state.shippingAddressInitialValidationRules,
          state.countryCode
        )
      ) {
        state.applePaySession.completePayment(
          ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS
        )
      }

      if (!isBillingContactValid(payment.billingContact, state.billingAddressValidationRules)) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS)
      }
    }

    state.successView = mq === DESKTOP ? ORDER_OK_VIEW : 'ThankYouPageView'

    try {
      const request = syncAjaxPOST(
        'AjaxApplePayOrderProcess',
        commonParameters +
          '&URL=' +
          state.successView +
          '&applePayErrorView=' +
          state.errorView +
          makeShippingAndBillingContactParameters(
            payment,
            selectedShippingModeIdParameter,
            state.strategy.extraApplePayParameterCreator
          ) +
          '&jsonView=true&isApplePay=true' +
          '&paymentToken_applePay=' +
          btoa(JSON.stringify(payment.token.paymentData)) +
          makePaymentTokenParameters(payment.token) +
          '&checkoutTime=' +
          new Date().getTime(),
        'application/x-www-form-urlencoded'
      )

      if (request.status === 404) {
        throw new Error('Error code:' + request.status)
      } else if (request.responseURL.indexOf(state.successView)) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS)
        dispatch(`pdp/${ACTION_TRACK_APPLEPAY_CLICK}`, {}, { root: true })
        state.strategy.showNextPage('', state.successView, 1, '', commonParameters)
      } else if (request.responseURL.indexOf(state.errorView)) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_FAILURE)
        state.strategy.showNextPage(state.errorView, state.successView, 0, '', commonParameters)
      }

      const data = request.response

      if (data.indexOf('ThankYouPage') !== -1) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS)
        state.strategy.showNextPage('', state.successView, 1, '', commonParameters)
      } else if (data.indexOf(SHOP_CART) !== -1) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_FAILURE)

        // TODO: Need to parse error from response HTML.
        // Rayban.analytics.applePayAjaxError(data)
      } else if (data.indexOf('PaymentPage') !== -1) {
        state.applePaySession.completePayment(ApplePaySession.STATUS_FAILURE)

        // TODO: Need to parse error from response HTML.
        // Rayban.analytics.applePayAjaxError(data)
      } else {
        state.applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS)
        dispatch(`pdp/${ACTION_TRACK_APPLEPAY_CLICK}`, {}, { root: true })

        state.strategy.showNextPage('', state.successView, 1, '', commonParameters)
      }

      state.strategy.onSentToken(data)
    } catch (e) {
      dispatch(`pdp/${ACTION_TRACK_APPLEPAY_ERROR}`, e.statusText, { root: true })
      state.applePaySession.completePayment(ApplePaySession.STATUS_FAILURE)
      // eslint-disable-next-line no-undef
      Rayban.analytics.applePayAjaxError(e)
    }
  },
}
